import { MutationConfig } from '@helpers';
import { useMutation, useQueryClient } from 'react-query';
import { getLinksReviewQueryOptions } from './get-links-management';
import { EditEnterpriseLinksManagementInput } from '../types';
import { ApiClientEnterpriseLinksReview } from '@helpers/apiClients';
import { successMessage } from '@services';

export const editLinksManagement = ({
  companyId,
  linkId,
  data,
}: {
  companyId: string;
  linkId: string;
  data: EditEnterpriseLinksManagementInput;
}) => {
  return ApiClientEnterpriseLinksReview.put(
    `/enterprise/${companyId}/link-reviews/${linkId}`,
    data,
  );
};

type UseEditLinksManagementOptions = {
  mutationConfig?: MutationConfig<typeof editLinksManagement>;
};

export const useEditLinkReview = ({ mutationConfig }: UseEditLinksManagementOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      successMessage('Link updated successfully');
      queryClient.invalidateQueries({
        queryKey: getLinksReviewQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: editLinksManagement,
  });
};
